import React from 'react';
import DocViewer, { PDFRenderer } from '@cyntler/react-doc-viewer';
import '@cyntler/react-doc-viewer/dist/index.css';
import * as Styled from './pdf-viewer.styles';
import { RolesValues } from '@constants';
import { RoleGuard } from '@shared-components';

interface PDFViewerProps {
  currentFile: string;
  fileName: string;
  close: () => void;
  roles?: Array<RolesValues>;
  insideModal?: boolean;
}

const PDFViewer: React.FC<PDFViewerProps> = ({ currentFile, fileName, insideModal, close, roles }) => {
  return (
    <Styled.Modal insideModal={insideModal}>
      <Styled.ModalActions>
        <Styled.ActionItem onClick={close}>
          <Styled.CustomIcon type="u_multiply" />
        </Styled.ActionItem>
        <RoleGuard roles={roles}>
          <Styled.ActionItem href={currentFile} download={fileName}>
            <Styled.CustomIcon type="u_download" size={20} viewBox="0 0 20 20" />
          </Styled.ActionItem>
        </RoleGuard>
      </Styled.ModalActions>
      <Styled.PDFViewerContainer>
        <DocViewer
          config={{
            header: { disableHeader: true },
            pdfVerticalScrollByDefault: true,
          }}
          documents={[{ uri: currentFile, fileName, fileType: 'pdf' }]}
          pluginRenderers={[PDFRenderer]}
          style={{ height: '100%' }}
        />
      </Styled.PDFViewerContainer>
    </Styled.Modal>
  );
};

export default PDFViewer;
